<script async setup>
import {ref, onMounted, watch, inject, provide, computed} from "vue";
import {getApiClient} from "../services/apiClientService"
import Modal from "./bootstrap/Modal.vue";
import ModalContentMedia from "./ModalContentMedia.vue";
import NotFound from "./NotFound.vue";
import { useRoute } from 'vue-router'

const emit = defineEmits(['setOpenFileIcon', 'setCameraCards']);
const { CHANNEL_PRIVATE, CHANNEL_PUBLIC, channel_selected, selectChannel } = inject('channel');
const { getAuthBearer,userLoggedIn,openLogin } = inject('userApi');
const { file_filter, setFilter, resetFilter, getFilterType } = inject('filter');

const route = useRoute()
const contentModal = ref(null);
const fileModalDataInit = {
  fileData: null,
  href: '',
  title: '',
  confidential: false,
};
const fileModalData = ref(Object.assign({},fileModalDataInit));

const icon_set = {
    city: false,
    casino: false,
    stadium: false,
    airport: false,
    harbour: false,
    industry: false,
    logistic: false,
    perimeter: false,
    about: false,
    document: false,
    camera: false,
    panomera: false,
    domera: false,
    project: false,
    video: false,
    youtube: false,
    pdf: false,
    image: false,
    ppt: false,
    security: false,
    critical: false,
    software: false,
    integration: false,
    link: false,
    website: false,
    default: false,
    search: false
};

const getIcons = function (file_data) {
    let filetype = file_data.filetype.filetype_id;
    let filetype_pattern = file_data.filetype.filetype_pattern
    let icons_keys = Object.keys(icon_set);
    let icons = Object.assign({},icon_set);
    let is_root = file_data.hasOwnProperty('file_children');

    let icon_pattern = file_data.file_name;
    if( filetype !== 'DIRECTORY'){
      icon_pattern = filetype.split('FILE_')[1];
    }else if(!is_root){
      icon_pattern = 'project';
    }
    icons_keys.forEach((icon_class) => {
      let match_class = new RegExp(icon_class);
      if(filetype_pattern !== undefined){
        let match_pattern = new RegExp(filetype_pattern);
        icons[icon_class] = match_pattern.test(file_data.url) ? match_class.test(file_data.url):false;
      }
      icons[icon_class] = !icons[icon_class] ? match_class.test(icon_pattern.toLowerCase()):true;
    });
    return icons
};

provide('icons',{
  icon_set,
  getIcons
});

const file_list = ref({
    channels:{
        public:[],
        private:[],
        camera_cards:[]
    },
    open_file_id: false,
    list: [],
    depth: 1
});


watch(
  () => route.name,
  (name) => {
    parseRoute();
    document.getElementById('content-list').scrollIntoView({ behavior: 'smooth' });
  }
)

const parseRoute = function () {
  let route_segments = route.name.split('.');
  let channel = route_segments[0];
  let secured = channel === CHANNEL_PRIVATE;
  selectChannel(channel)
  file_list.value.depth = route_segments.length;
  if(secured && userLoggedIn.value || !secured){
    loadFile(secured);
    if(secured){
      loadCameraCards();
    }
  }else{
    let redirect_to = encodeURI(location.pathname+window.location.hash);
    openLogin(redirect_to);
  }
};

const filterListItem = function (item) {
  let filter_matched = true;
  Object.entries(file_filter.value).forEach(([filter_type, filter]) => {
    if(filter.active){
      if(filter_type === 'language'){
        const filter_rule =   /_(de|en)\./mgi;
        const filter_exec = new RegExp(`_(${filter.value})\\.[^.]+$`, 'i');
        if(filter_rule.exec(item.file_name) !== null){
          filter_matched = filter_exec.exec(item.file_name) !== null;
        }else{
          filter_matched = true;
        }
      }
      if(filter_type === 'types' && filter_matched){
        let filter_type_match = false;
        filter.value.forEach((filetype_id) => {
          if(!filter_type_match){
            filter_type_match = filter.value.includes(item.filetype.filetype_id);

            let filetype = getFilterType(filetype_id);
            if(filetype){
              if(filetype.filetype_pattern !== undefined){
                let match_pattern = new RegExp(filetype.filetype_pattern);
                filter_type_match = match_pattern.test(item.url);
              }
            }

            let youtube_pattern = new RegExp('.*\\.youtube');
            if(filetype_id === 'FILE_LINK' && youtube_pattern.test(item.url)){
              filter_type_match = false;
            }
            if(filetype_id === 'FILE_VIDEO' && youtube_pattern.test(item.url)){
              filter_type_match = true;
            }
          }
        })
        filter_matched = filter_type_match
      }
    }
  });
  return filter_matched;
}

const filterList = function (file_list) {
  let file_list_filtered = [];
  file_list.forEach((item) => {
    if(filterListItem(item)){
      file_list_filtered.push(item);
    }
  })
  return file_list_filtered;
}

const matchFileTitle = function (file) {
  let title = file.title.toLowerCase().split(/\W+/);
  let search_list = file_filter.value.search.value.split(/\W+/);
  return search_list.every(word_pattern =>
    title.some(word => word.includes(word_pattern.toLowerCase()))
  );
}

const searchInList = function (chanel_file_list) {
  let file_list_search = [];
  chanel_file_list.forEach((category) => {
    let category_children = getFileChildren(category.file_id);
    category_children.forEach((file) => {
      if(matchFileTitle(file)){
        file_list_search.push(file);
      }
    })
  })
  return file_list_search;
}

const setActiveList = function() {
    let file_id = getSelectedFileId();
    if(file_id){
        file_list.value.open_file_id = file_id;
        let children = getFileChildren(file_list.value.open_file_id);
        if(children.length > 0){
          let open_file = getOpenFile(file_id);
          emit('setOpenFileIcon', getIcons(open_file[0]));

          file_list.value.list = filterList(children);
        }
    }else{
        if(!file_filter.value.search.active){
          if(route.name.split('.').pop()==='camera_cards'){
            emit('setOpenFileIcon', {project: true});
          }else{
            emit('setOpenFileIcon', Object.assign({},icon_set));
          }
          file_list.value.open_file_id = false;
          file_list.value.list =  getActiveChannelList();
        }else{
          emit('setOpenFileIcon', {search: true});
          file_list.value.list = searchInList(getActiveChannelList())
        }
    }
};

const list_empty = computed(()=>{
  let item_count = 0;
  for (let listItem of file_list.value.list) {
    if(listItem.parent_file_id !== undefined) {
        item_count++;
        continue;
    }
    if(listItem.file_children.length > 0){
      item_count++;
    }
  }
  return item_count === 0;
})

const getSelectedFileId = function () {
  let file_id = false;
  if(Object.hasOwn(route.params, 'file_id')){
    file_id =  route.params.file_id;
  }
  return file_id;
};

const getActiveChannelList = function () {
    return file_list.value.channels[channel_selected.value]
};

const getOpenFile = function (file_id) {
    let active_channel_list = getActiveChannelList();
    return active_channel_list.filter((file) => {
        return file.file_id === file_id;
    });
};

const getFileChildren = function (file_id){
    let children = [];
    let open_file = getOpenFile(file_id);
    if(open_file.length > 0){
      children = open_file[0].file_children
    }
    return children;
};

const loadFile = function (secured = false) {
    let active_channel_list = getActiveChannelList()
    if(active_channel_list.length === 0 || channel_selected.value === CHANNEL_PRIVATE){
      const apiClient = getApiClient();
      apiClient.get(`/file/${channel_selected.value}`,).then(response => {
          file_list.value.channels[channel_selected.value] = response.data;
          setActiveList();
      }).catch(error => {
            console.error(error.message);
      }).finally(() => {
        // loadingState.value = false;
      });
    }else{
        setActiveList();
    }
};

watch(file_filter.value,(filter)=>{
  setActiveList();
});

const loadCameraCards = () => {
  if(file_list.value.channels.camera_cards.length === 0){
    const apiClient = getApiClient();
    apiClient.get('/camera_cards').then(response => {
      file_list.value.channels.camera_cards = response.data;
    }).catch(error => {
      console.error('camera cards load error',error.message);
    })
  }
}

const modalCreated = function (modal) {
  contentModal.value = modal;
  contentModal.value._element.addEventListener('hidden.bs.modal', event => {
    fileModalData.value = Object.assign({},fileModalDataInit);
  })
};

const openInModal = function ({file,href,title,confidential}) {
  fileModalData.value.fileData = file;
  fileModalData.value.href = href;
  fileModalData.value.title = title;
  fileModalData.value.confidential = confidential
  console.log('openInModal', confidential);
  contentModal.value.show();
};

onMounted(()=>{
    parseRoute();
});

</script>

<template>
  <div id="content-list" class="row content" :class="{'directory-root': file_list.depth < 2 && !file_filter.search.active, 'filter-active': file_filter.show_filter}">
    <div class="list-group list-group-flush pe-0">
      <NotFound v-if="list_empty"></NotFound>
      <router-view :file-list="file_list" @open-in-modal="openInModal"></router-view>
    </div>
  </div>
  <teleport to="body">
    <Modal :title="fileModalData.title" :share="fileModalData.href" :size="'modal-fullscreen'" :footer-close="true" :content-confidential="fileModalData.confidential" @modal-created="modalCreated">
      <ModalContentMedia :file-data="fileModalData.fileData" :href="fileModalData.href"></ModalContentMedia>
    </Modal>
  </teleport>
</template>